import { RootState } from "src/redux/store";

const root = (s: RootState) => s.experiences.storyboardSettings;

// Storyboard
export const selectStoryboard = (s: RootState) => root(s).storyboard.item;
export const selectStoryboardLoading = (s: RootState) => root(s).storyboard.loading;
export const selectStoryboardError = (s: RootState) => root(s).storyboard.error;
export const selectStoryboardFetched = (s: RootState) => root(s).storyboard.fetched;

// Draft
export const selectStoryboardDraft = (s: RootState) => root(s).draft.item;
export const selectStoryboardIsDirty = (s: RootState) => root(s).draft.isDirty;

// Per-storyboard gating configurations live on the draft document.
// Convenience selector so cards don't reach into draft.item manually.
export const selectGatingConfigurations = (s: RootState) =>
  root(s).draft.item?.gatingConfigurations ?? [];

// Domains
export const selectDomains = (s: RootState) => root(s).domains.items;
export const selectDomainsLoading = (s: RootState) => root(s).domains.loading;
export const selectDomainsError = (s: RootState) => root(s).domains.error;

// Workspace-wide gating catalog (UI-only — never sent to save)
export const selectGatingCatalog = (s: RootState) => root(s).gatingCatalog.items;
export const selectGatingCatalogLoading = (s: RootState) =>
  root(s).gatingCatalog.loading;
export const selectGatingCatalogFetched = (s: RootState) =>
  root(s).gatingCatalog.fetched;

// Storyboard pages (for Page Selection dropdown)
export const selectStoryboardPages = (s: RootState) =>
  root(s).storyboardPages.items;
export const selectStoryboardPagesLoading = (s: RootState) =>
  root(s).storyboardPages.loading;

// Users
export const selectUsers = (s: RootState) => root(s).users.items;
export const selectUsersLoading = (s: RootState) => root(s).users.loading;
export const selectUsersError = (s: RootState) => root(s).users.error;
